import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MessagingActions } from "../../actions/messaging.actions";
import { ConversationState } from "../../models/messaging/conversation-state";

const initialState: ConversationState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MessagingActions.conversation.get, (state) =>
		_.merge(_.cloneDeep(state), { loading: true })
	),
	on(MessagingActions.conversation.getSuccess, (state, action) => {
		if (!state.conversations?.length) {
			return {
				...state,
				loading: false,
				conversations: action.conversations
			};
		}

		const updatedConversations = state.conversations.map((existing) => {
			const updated = action.conversations.find((c) => c.id === existing.id);
			return updated ?? existing;
		});

		const newConversations = action.conversations.filter(
			(newConv) => !state.conversations?.some((existing) => existing.id === newConv.id)
		);

		return {
			...state,
			loading: false,
			conversations: [...updatedConversations, ...newConversations]
		};
	}),
	on(MessagingActions.conversation.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), { error: action.error, loading: false })
	)
);

export function conversationReducer(
	state: ConversationState | undefined,
	action: Action
): ConversationState {
	return reducer(state, action);
}
